export default "__VITE_ASSET__B8g1qtGN__"